import type { ApiClient } from '../client';
import type {
  ApiResponse,
  GenerateTimetableRequest,
  GenerateTimetableResponse,
  ListTimetableSlotsResponse,
} from '../types';

export function bindTimetable(client: ApiClient) {
  return {
    async generateTimetable(body: GenerateTimetableRequest): Promise<ApiResponse<GenerateTimetableResponse>> {
      return client.request<GenerateTimetableResponse>('/timetable/generate', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    },

    async listTimetableSlots(params?: { limit?: number; offset?: number; page?: number }): Promise<
      ApiResponse<ListTimetableSlotsResponse>
    > {
      const qs = new URLSearchParams();
      if (params?.limit != null) qs.set('limit', String(params.limit));
      if (params?.offset != null) qs.set('offset', String(params.offset));
      if (params?.page != null) qs.set('page', String(params.page));
      const query = qs.toString();
      return client.request<ListTimetableSlotsResponse>(`/timetable/slots${query ? `?${query}` : ''}`);
    },
  };
}
